var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66659 2.66634V13.333H5.33325V10.001C5.33325 9.63282 5.63173 9.33434 5.99992 9.33434H9.21925C9.28306 9.33434 9.33458 9.28282 9.33458 9.21901V5.99834C9.33458 5.63015 9.63306 5.33167 10.0013 5.33167H13.3333V2.66634H2.66659ZM1.33325 2.64834C1.33325 1.92215 1.9224 1.33301 2.64859 1.33301H13.3513C14.0774 1.33301 14.6666 1.92215 14.6666 2.64834V5.34967C14.6666 5.69852 14.528 6.03308 14.2813 6.27976C14.0347 6.52643 13.7001 6.66501 13.3513 6.66501H10.6679V9.21901C10.6679 10.0192 10.0194 10.6677 9.21925 10.6677H6.66658V13.351C6.66658 13.5239 6.63252 13.695 6.56633 13.8547C6.50015 14.0143 6.40314 14.1594 6.28086 14.2816C6.15857 14.4037 6.01341 14.5006 5.85367 14.5666C5.69393 14.6326 5.52275 14.6665 5.3499 14.6663L5.35058 13.9997V14.6663H5.3499H2.64859C2.29974 14.6663 1.96518 14.5278 1.7185 14.2811C1.47183 14.0344 1.33325 13.6999 1.33325 13.351V2.64834Z",
    fill: "#566982"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoom);
export default __webpack_public_path__ + "static/media/room.9899e959d64b49efa361863978b06805.svg";
export { ForwardRef as ReactComponent };